import { styled } from '@mui/material/styles';
import { Box, Typography, Avatar } from '@mui/material';
import cssStyles from '../../utils/cssStyles';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import createAvatar from '../../utils/createAvatar';
import Image from '../image';

const RootStyle = styled('div')(({ theme }) => ({
    '&:before': {
        ...cssStyles().bgBlur({ blur: 2, color: theme.palette.primary.dark }),
        top: 0,
        zIndex: 9,
        content: "''",
        width: '100%',
        height: '100%',
        position: 'absolute',
    },
}));
  
const InfoStyle = styled('div')(({ theme }) => ({
    left: 0,
    right: 0,
    zIndex: 99,
    position: 'absolute',
    marginTop: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
        right: 'auto',
        display: 'flex',
        alignItems: 'center',
        left: theme.spacing(3),
        bottom: theme.spacing(3),
    },
}));

export const ProfileCover = () => {
    const { authUser } = useSelector((state: RootState) => state.auth);
    const { details } = useSelector((state: RootState) => state.customer);

    return (
        <RootStyle>
            <InfoStyle>
                <Avatar 
                    alt={details?.customer?.name}
                    color={createAvatar(details?.customer?.name).color}
                    sx={{
                        mx: 'auto',
                        borderWidth: 2,
                        borderStyle: 'solid',
                        borderColor: 'common.white',
                        width: { xs: 80, md: 128 },
                        height: { xs: 80, md: 128 },
                    }}
                >
                    {createAvatar(authUser?.fullname).name}
                </Avatar>
                <Box
                    sx={{
                        ml: { md: 3 },
                        mt: { xs: 1, md: 0 },
                        color: 'common.white',
                        textAlign: { xs: 'center', md: 'left' },
                    }}
                >
                    <Typography variant="h4">{authUser?.fullname}</Typography>
                    <Typography sx={{ opacity: 0.72 }}>{authUser?.email}</Typography>
                </Box>
            </InfoStyle>
            <Image 
                alt="profile cover" 
                src={'https://minimal-assets-api-dev.vercel.app/assets/images/covers/cover_23.jpg'} 
                sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }} 
                disabledEffect={false}
            />
        </RootStyle>
    )
};